import PublicationFile from './PublicationFile'
import uniqid from 'uniqid'

const PublicationFiles = ({files, editMode}) => {
  return (
    <section className="publication-files">
      {files.map(file => (
        <PublicationFile
          editMode={editMode}
          key={uniqid()}
          file={file}
          showPreview={files.length === 1}
        />
      ))}
    </section>
  )
}

export default PublicationFiles
